import { MeasurementsState, PatientState } from 'src/types/measurements';
import { PatientsMeasurementsType } from 'src/services/types';

export const extractBedState = (bedState?: string): PatientState => {
  switch (bedState) {
    case 'OUT_OF_BED':
      return PatientState.EMPTY;
    case 'IN_BED':
      return PatientState.OCCUPIED;
    default:
      return PatientState.UNKNOWN;
  }
};

const displayNumberOrDecimal = (value: string | number | undefined) => {
  return Number.isInteger(Number(value))
    ? value?.toString()
    : Number(value).toFixed(1).toString();
};
export const extractVsFromMeasurement = (
  patientMeasurements: PatientsMeasurementsType,
  patientBedState?: string,
): Record<string, MeasurementsState> | null => {
  if (!patientMeasurements || !patientMeasurements?.patientId) {
    return null;
  }
  const hrMeasurements =
    patientMeasurements?.measurementsByMetric?.HR?.continuousMeasurements;
  const rrMeasurements =
    patientMeasurements?.measurementsByMetric?.RR?.continuousMeasurements;
  const raMeasurements =
    patientMeasurements?.measurementsByMetric?.RA_bin?.continuousMeasurements;
  const ieMeasurements =
    patientMeasurements?.measurementsByMetric?.IE?.continuousMeasurements;

  const currentHrValue = hrMeasurements
    ? Number(hrMeasurements?.[hrMeasurements.length - 1]?.average).toFixed()
    : '0';
  const currentRrValue = rrMeasurements
    ? Number(rrMeasurements?.[rrMeasurements.length - 1]?.average).toFixed()
    : '0';
  const currentRabinValue = raMeasurements
    ? Number(raMeasurements?.[raMeasurements.length - 1]?.average).toFixed()
    : '0';
  const currentIeValue = ieMeasurements
    ? displayNumberOrDecimal(
        ieMeasurements?.[ieMeasurements.length - 1]?.average,
      )
    : '0';

  const currentIERatioValue =
    currentIeValue && Number(currentIeValue) >= 0
      ? Number(currentIeValue).toFixed(1)
      : '-1';
  const currentHrQuality = true;
  const currentRrQuality = true;
  const currentRabinQuality = true;
  const currentPatientStateValue = extractBedState(patientBedState);
  const isPatientOutOfBed = currentPatientStateValue === PatientState.EMPTY;
  return {
    [patientMeasurements.patientId]: {
      currentHrValue: isPatientOutOfBed ? '0' : currentHrValue,
      currentHrQuality,
      currentRrValue: isPatientOutOfBed ? '0' : currentRrValue,
      currentRrQuality,
      currentRabinValue: isPatientOutOfBed ? '0' : currentRabinValue,
      currentRabinQuality,
      currentIERatioValue: isPatientOutOfBed ? '0' : currentIERatioValue,
      currentPatientStateValue,
    },
  };
};
